import { ReviewsIoStoreId } from 'config/constants/reviews-io';
import sharedEnvironment from 'config/shared-environment';
import { ShopId } from 'constants/shop';

const TRUSTED_SHOPS_ID = 'X7E9B2883799E421BB61E5F3E849E4248';

/**
 * Environment values shared by dev, staging and production for the CH shop.
 */
// TODO: common env should be placed in the root of the config per locale
export default {
  ...sharedEnvironment,
  cookieDomain: '.petsdeli.ch',
  currencyCode: 'CHF',
  shopId: ShopId.CH,
  trustedShopsId: TRUSTED_SHOPS_ID,
  trustedShopsUrl: `https://www.trustedshops.ch/bewertung/info_${TRUSTED_SHOPS_ID}.html`,
  reviewsIoStoreId: ReviewsIoStoreId.CH,
};
